//import moment from 'moment';
import Swal from "sweetalert2";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import autoTable from "jspdf-autotable";

export function dateFormat(dateString) {
  if (dateString) {
    //////const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    //console.log("dateString", timeZone);
    //  const date = new Date(dateString);
    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, '0'); // 0-indexed
    //   const day = String(date.getDate()).padStart(2, '0');

    //   return `${month}/${day}/${year}`;
    //return `${month}/${day}/${year}`;
    //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // // Detect if only date (no time)
    // const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);

    // let date = isDateOnly
    //   ? moment.tz(dateString, 'YYYY-MM-DD', timeZone) // interpret in local tz
    //   : moment.utc(dateString).tz(timeZone); // convert from UTC

    // return date.format('MM/DD/YYYY');
    const dateOnly = moment.utc(dateString).format("YYYY-MM-DD");
    const [year, month, day] = dateOnly.split("-");
    return `${month}/${day}/${year}`;
  }
}

// Normalize various date string formats to a target format (default YYYY-MM-DD)
export function normalizeDateString(
  value,
  targetFormat = "YYYY-MM-DD",
  inputFormats = [
    "YYYY-MM-DD",
    "YYYY-M-D",
    "MM/DD/YYYY",
    "M/D/YYYY",
    "DD/MM/YYYY",
    "D/M/YYYY",
  ]
) {
  if (!value) return "";
  // Handle Date instance directly
  if (value instanceof Date && !isNaN(value)) {
    return moment(value).format(targetFormat);
  }
  const m = moment(value, inputFormats, true);
  return m.isValid() ? m.format(targetFormat) : "";
}
export function currentDateFormat(currentDate) {
  const formattedDate = moment(currentDate).format("MMMM DD, YYYY");
  return formattedDate;
}
export function capitalizeFirstLetter(str) {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
export function capitalizeWords(str) {
  return str.replace(/\b\w+/g, (word) => word.toUpperCase());
}
export function restrictZipInput(e) {
  const zipInput = e.target;
  const value = zipInput.value.replace(/[^0-9]/g, "");
  const maxLength = 5;

  if (value.length > maxLength) {
    zipInput.value = value.substring(0, maxLength);
  } else {
    zipInput.value = value;
  }
}
export function restrictNumberInput(e) {
  const zipInput = e.target;
  const value = zipInput.value.replace(/[^0-9]/g, "");
  const maxLength = 2;

  if (value.length > maxLength) {
    zipInput.value = value.substring(0, maxLength);
  } else {
    zipInput.value = value;
  }
}
export function allowOnlyNumberKey(e) {
  const key = e.key;
  const isNumber = /^[0-9]$/.test(key);
  if (
    !isNumber &&
    key !== "Backspace" &&
    key !== "Delete" &&
    key !== "ArrowLeft" &&
    key !== "ArrowRight" &&
    key !== "Tab"
  ) {
    e.preventDefault(); // block the input
  }
}
export function convertShortTime(input) {
  const padded = input.toString().padStart(4, "0"); // '815' → '0815'
  return moment(padded, "HHmm").format("hh:mm A"); // → '08:15 AM'
}
export const generateBillingInvoicePDF = (
  billingItems,
  fileName = "Billing_Invoice.pdf"
) => {
  if (!billingItems || billingItems.length === 0) {
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  let yPosition = margin;

  // Helper function to format address from new API structure
  const formatAddress = (addressObj) => {
    if (!addressObj) return "N/A";
    // Use full_address if available, otherwise construct from parts
    if (addressObj.full_address) {
      return addressObj.full_address;
    }
    const parts = [];
    if (addressObj.address1) parts.push(addressObj.address1);
    if (addressObj.address2) parts.push(addressObj.address2);
    if (addressObj.city) parts.push(addressObj.city);
    if (addressObj.state) parts.push(addressObj.state);
    if (addressObj.zip) parts.push(addressObj.zip);
    return parts.length > 0 ? parts.join(", ") : "N/A";
  };

  // Helper function to format location address from new API structure
  const formatLocationAddress = (location) => {
    if (!location) return "N/A";
    // Use full_address if available, otherwise construct from parts
    if (location.full_address) {
      return location.full_address;
    }
    const parts = [];
    if (location.loc_name) parts.push(location.loc_name);
    if (location.loc_address) parts.push(location.loc_address);
    if (location.loc_city) parts.push(location.loc_city);
    if (location.loc_state_id) parts.push(location.loc_state_id);
    if (location.loc_zip) parts.push(location.loc_zip);
    return parts.length > 0 ? parts.join(", ") : "N/A";
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return moment(dateString).format("MM/DD/YYYY");
    } catch (e) {
      return dateString;
    }
  };

  // Helper function to format DOB
  const formatDOB = (dob) => {
    if (!dob) return "N/A";
    try {
      return moment(dob).format("MM/DD/YYYY");
    } catch (e) {
      return dob;
    }
  };

  // Helper function to format time
  const formatTime = (timeString) => {
    if (!timeString) return "N/A";
    // If time is in HH:mm format, convert to 12-hour format
    if (timeString.includes(":")) {
      try {
        const [hours, minutes] = timeString.split(":");
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
      } catch (e) {
        return timeString;
      }
    }
    return timeString;
  };

  // Helper function to format agency address
  const formatAgencyAddress = (agencyDetails) => {
    if (!agencyDetails) return "";
    const parts = [];
    if (agencyDetails.address1) parts.push(agencyDetails.address1);
    if (agencyDetails.city) parts.push(agencyDetails.city);
    if (agencyDetails.state_master_list?.state_code) {
      parts.push(agencyDetails.state_master_list.state_code);
    }
    if (agencyDetails.zip) parts.push(agencyDetails.zip.toString());
    return parts.join(", ");
  };

  // Process each billing item
  billingItems.forEach((item, index) => {
    // Add new page for each invoice (except the first one)
    if (index > 0) {
      doc.addPage();
      yPosition = margin;
    }

    // // Agency Details in top left corner
    // if (item.agency_details) {
    //   doc.setFontSize(10);
    //   doc.setFont('helvetica', 'normal');
    //   const agencyAddress = formatAgencyAddress(item.agency_details);
    //   if (agencyAddress) {
    //     const agencyLines = doc.splitTextToSize(agencyAddress, pageWidth / 2 - margin);
    //     doc.text(agencyLines, margin, yPosition);
    //     yPosition += agencyLines.length * 5 + 5;
    //   }
    // }

    // Header
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("BILLING INVOICE", pageWidth / 2, yPosition, { align: "center" });
    yPosition += 5;

    // Underline after BILLING INVOICE
    doc.setLineWidth(0.5);
    const textWidth = doc.getTextWidth("BILLING INVOICE");
    const underlineStartX = (pageWidth - textWidth) / 2;
    const underlineEndX = underlineStartX + textWidth;
    doc.line(underlineStartX, yPosition, underlineEndX, yPosition);
    yPosition += 10;

    // Agency Details in top left corner
    if (item.agency_details) {
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      const agencyAddress = formatAgencyAddress(item.agency_details);
      if (agencyAddress) {
        const agencyLines = doc.splitTextToSize(
          agencyAddress,
          pageWidth / 2 - margin
        );
        doc.text(agencyLines, margin, yPosition);
        yPosition += agencyLines.length * 5 + 5;
      }
    }

    // Schedule ID
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const scheduleId = item.schedule_id || "N/A";
    doc.text(`Schedule ID: ${scheduleId}`, margin, yPosition);
    yPosition += 8;

    // Passenger Details Section
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Passenger Details:", margin, yPosition);
    yPosition += 7;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const passengerName = item.passenger_details?.name || "N/A";
    doc.text(`Name: ${passengerName}`, margin, yPosition);
    yPosition += 6;

    const passengerDOB = item.passenger_details?.dob
      ? formatDOB(item.passenger_details.dob)
      : "N/A";
    doc.text(`Date of Birth: ${passengerDOB}`, margin, yPosition);
    yPosition += 6;

    const passengerAddress = formatAddress(item.passenger_details?.address);
    const addressLines = doc.splitTextToSize(
      `Address: ${passengerAddress}`,
      pageWidth - 2 * margin
    );
    doc.text(addressLines, margin, yPosition);
    yPosition += addressLines.length * 5 + 3;

    // Trip Details
    doc.setFont("helvetica", "bold");
    doc.text("Trip Details:", margin, yPosition);
    yPosition += 7;

    doc.setFont("helvetica", "normal");
    const tripDate = formatDate(item.trip_date || item.schedule_date);
    doc.text(`Trip Date: ${tripDate}`, margin, yPosition);
    yPosition += 6;

    const totalMiles = item.miles_traveled || 0;
    doc.text(
      `Total Miles Travelled: ${totalMiles.toFixed(2)}`,
      margin,
      yPosition
    );
    yPosition += 6;

    const noOfLegs = item.no_of_leg || item.leg_details?.length || 0;
    doc.text(`Number of Legs: ${noOfLegs}`, margin, yPosition);
    yPosition += 6;

    doc.text(
      `NEMT Service Name: ${item.nemt_service_name || "N/A"}`,
      margin,
      yPosition
    );
    yPosition += 6;

    doc.text(`Base Code: ${item.base_code || "N/A"}`, margin, yPosition);
    yPosition += 6;

    doc.text(`Mileage Code: ${item.milage_code || "N/A"}`, margin, yPosition);
    yPosition += 8;

    // Pickup and Dropoff Details
    const pickUpDetails = item.pick_up_details || [];
    const dropOffDetails = item.drop_off_details || [];
    const legDetails = item.leg_details || [];
    const maxLegs = Math.max(
      pickUpDetails.length,
      dropOffDetails.length,
      legDetails.length
    );

    if (maxLegs > 0) {
      doc.setFont("helvetica", "bold");
      doc.text("Trip Legs Details:", margin, yPosition);
      yPosition += 7;

      doc.setFont("helvetica", "normal");

      for (let legIndex = 0; legIndex < maxLegs; legIndex++) {
        if (yPosition > pageHeight - 60) {
          doc.addPage();
          yPosition = margin;
        }

        doc.setFont("helvetica", "bold");
        doc.text(`Leg ${legIndex + 1}:`, margin, yPosition);
        yPosition += 6;

        doc.setFont("helvetica", "normal");

        const leg = legDetails[legIndex];
        const legDriverName = leg?.driver_name || "N/A";
        doc.text(`Driver Name: ${legDriverName}`, margin + 5, yPosition);
        yPosition += 6;

        // Pickup details
        if (pickUpDetails[legIndex]) {
          const pickup = pickUpDetails[legIndex];
          const pickupAddress = formatLocationAddress(pickup.location);
          const pickupLines = doc.splitTextToSize(
            `Pickup: ${pickupAddress}`,
            pageWidth - 2 * margin - 5
          );
          doc.text(pickupLines, margin + 5, yPosition);
          yPosition += pickupLines.length * 5;

          const pickupTime = formatTime(pickup.time);
          doc.text(`Pickup Time: ${pickupTime}`, margin + 5, yPosition);
          yPosition += 6;
        }

        // Dropoff details
        if (dropOffDetails[legIndex]) {
          const dropoff = dropOffDetails[legIndex];
          const dropoffAddress = formatLocationAddress(dropoff.location);
          const dropoffLines = doc.splitTextToSize(
            `Dropoff: ${dropoffAddress}`,
            pageWidth - 2 * margin - 5
          );
          doc.text(dropoffLines, margin + 5, yPosition);
          yPosition += dropoffLines.length * 5;

          const dropoffTime = formatTime(dropoff.time);
          doc.text(`Dropoff Time: ${dropoffTime}`, margin + 5, yPosition);
          yPosition += 6;
        }

        // Leg billing details
        if (leg) {
          doc.text(`Miles: ${leg.miles || "0.00"}`, margin + 5, yPosition);
          yPosition += 5;
          doc.text(
            `Base Rate: $${parseFloat(leg.base_bill_rate || 0).toFixed(2)}`,
            margin + 5,
            yPosition
          );
          yPosition += 5;
          doc.text(
            `Mileage Rate: $${parseFloat(leg.mileage_bill_rate || 0).toFixed(
              2
            )}`,
            margin + 5,
            yPosition
          );
          yPosition += 5;
          doc.setFont("helvetica", "bold");
          doc.text(
            `Leg Amount: $${parseFloat(leg.leg_amount || 0).toFixed(2)}`,
            margin + 5,
            yPosition
          );
          yPosition += 8;
          doc.setFont("helvetica", "normal");
        }

        yPosition += 3;
      }
    }

    // Total Amount
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    const totalAmount = item.total_amount || 0;
    doc.text(
      `Total Amount: $${totalAmount.toFixed(2)}`,
      margin,
      yPosition
    );
    yPosition += 10;

    // Separator line
    doc.setLineWidth(0.5);
    doc.line(margin, yPosition, pageWidth - margin, yPosition);
    yPosition += 5;
  });

  // Save the PDF
  doc.save(fileName);
};

const formatPdfPersonName = (person) => {
  if (!person) return "N/A";
  if (person?.full_name) return String(person.full_name);
  const parts = [
    person?.first_name ?? person?.firstName,
    person?.middle_name ?? person?.middleName,
    person?.last_name ?? person?.lastName,
  ].filter((part) => part != null && String(part).trim() !== "");
  return parts.join(" ") || "N/A";
};

const formatPdfDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    return moment(dateString).format("MM/DD/YYYY");
  } catch (e) {
    return dateString;
  }
};

const getSubmissionBillingLegs = (item) => {
  if (Array.isArray(item?.legs) && item.legs.length > 0) {
    return item.legs;
  }
  const fromLegDetails =
    item?.leg_details ?? item?.schedule?.leg_details ?? item?.schedule_trans;
  if (Array.isArray(fromLegDetails) && fromLegDetails.length > 0) {
    return fromLegDetails;
  }
  const scheduleTran = item?.schedule_tran ?? item?.schedule_trans;
  if (Array.isArray(scheduleTran) && scheduleTran.length > 0) {
    return scheduleTran;
  }
  if (scheduleTran && typeof scheduleTran === "object") {
    return [scheduleTran];
  }
  return [];
};

const formatSubmissionDriverLabel = (leg, legIdx) => {
  const legNum = leg?.leg_number ?? leg?.no_of_leg ?? legIdx + 1;
  const driver = formatPdfPersonName(leg?.driver);
  return `Leg ${legNum}: ${driver}`;
};

const calculateSubmissionLegAmount = (leg, nemtServiceRate) => {
  const miles = parseFloat(leg?.miles);
  const baseRate = parseFloat(nemtServiceRate?.base_bill_rate ?? 0);
  const mileageRate = parseFloat(nemtServiceRate?.mileage_bill_rate ?? 0);
  if (!Number.isFinite(miles)) return null;
  const base = Number.isFinite(baseRate) ? baseRate : 0;
  const mileage = Number.isFinite(mileageRate) ? mileageRate : 0;
  return miles * mileage + base;
};

const formatSubmissionCurrencyAmount = (value) => {
  if (value == null || value === "") return "N/A";
  const num = parseFloat(value);
  return Number.isFinite(num) ? `$${num.toFixed(2)}` : "N/A";
};

const getSubmissionClaimTotals = (item, legs, nemtServiceRate) => {
  const totalMilesRaw = item?.total?.total_miles;
  const totalAmountRaw = item?.total?.total_amount;

  const fallbackMiles = legs.reduce((sum, leg) => {
    const miles = parseFloat(leg?.miles);
    return sum + (Number.isFinite(miles) ? miles : 0);
  }, 0);
  const fallbackAmount = legs.reduce((sum, leg) => {
    const legAmount = calculateSubmissionLegAmount(leg, nemtServiceRate);
    return sum + (legAmount != null ? legAmount : 0);
  }, 0);

  return {
    totalMiles:
      totalMilesRaw != null && totalMilesRaw !== ""
        ? String(totalMilesRaw)
        : String(fallbackMiles),
    totalAmount: formatSubmissionCurrencyAmount(
      totalAmountRaw != null && totalAmountRaw !== ""
        ? totalAmountRaw
        : fallbackAmount,
    ),
  };
};

const getSubmissionProcedureCode = (item) => {
  const baseCode = item?.nemtServiceRate?.serviceDetails?.base_code;
  if (baseCode == null || String(baseCode).trim() === "") return null;
  return String(baseCode).trim();
};

const drawSubmissionClaimInfoBox = (
  doc,
  startY,
  passengerDetails,
  procedureCode,
  margin,
  pageWidth,
) => {
  const leftLines = [
    `Passenger : ${passengerDetails.passengerName}`,
    `PMI Number: ${passengerDetails.pmiNo}`,
    `Payer      : ${passengerDetails.payerName}`,
  ];
  if (passengerDetails.hasServiceAuth) {
    leftLines.push(`SA Number  : ${passengerDetails.saNumber}`);
  }

  const boxHeight = leftLines.length * 7 + 6;
  const boxWidth = pageWidth - 2 * margin;
  const rightColumnX = margin + boxWidth / 2 + 4;

  doc.setFillColor(240, 240, 240);
  doc.rect(margin, startY, boxWidth, boxHeight, "F");
  doc.setDrawColor(200, 200, 200);
  doc.rect(margin, startY, boxWidth, boxHeight, "S");

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  leftLines.forEach((line, index) => {
    doc.text(line, margin + 4, startY + 7 + index * 7);
  });
  if (procedureCode) {
    doc.text(`Procedure Code : ${procedureCode}`, rightColumnX, startY + 7);
  }

  return startY + boxHeight + 6;
};

const getSubmissionPassengerDetails = (item) => {
  const passenger = item?.passenger ?? {};
  const nested = passenger?.passenger ?? {};
  const serviceAuth = nested?.serviceAuth;
  const hasServiceAuth =
    Array.isArray(serviceAuth) && serviceAuth.length > 0;
  const saNumber = hasServiceAuth
    ? serviceAuth[0]?.sa_number ?? null
    : null;

  return {
    passengerName: formatPdfPersonName(passenger),
    pmiNo: nested?.pass_pmi_no ?? passenger?.pass_pmi_no ?? "N/A",
    payerName:
      nested?.payerDetails?.payer_name ??
      passenger?.payerDetails?.payer_name ??
      item?.payer_name ??
      "N/A",
    hasServiceAuth: hasServiceAuth && saNumber != null && String(saNumber).trim() !== "",
    saNumber: saNumber != null ? String(saNumber).trim() : "",
  };
};

export const aggregateSubmissionBatchTotals = (items) => {
  const list = Array.isArray(items) ? items : [];
  return list.reduce(
    (acc, item) => {
      const itemMiles = parseFloat(item?.total?.total_miles);
      const itemAmount = parseFloat(item?.total?.total_amount);
      return {
        total_miles:
          acc.total_miles +
          (Number.isFinite(itemMiles) ? itemMiles : 0),
        total_amount:
          acc.total_amount +
          (Number.isFinite(itemAmount) ? itemAmount : 0),
      };
    },
    { total_miles: 0, total_amount: 0 },
  );
};

const getSubmissionBillingStatusLabel = (status) => {
  const labels = {
    1: "Ready",
    2: "Submitted",
    3: "Processing",
    4: "Rejected",
  };
  if (status == null || status === "") return "N/A";
  return labels[status] ?? String(status);
};

const getAgencyInfoForPdf = (agencyInfo) => {
  try {
    if (agencyInfo) return agencyInfo;
    const stored = localStorage.getItem("userData");
    if (!stored) return {};
    const userData = JSON.parse(stored);
    return userData?.agencyInfo ?? userData?.agencyDetails ?? userData ?? {};
  } catch (e) {
    return {};
  }
};

export const generateSubmittedBatchPDF = (
  batchItems,
  options = {},
  fileName = "batch-export.pdf",
) => {
  const items = Array.isArray(batchItems) ? batchItems : [];
  if (items.length === 0) return;

  const { agencyInfo: agencyInfoOption } = options;
  const agencyInfo = getAgencyInfoForPdf(agencyInfoOption);
  const companyName =
    agencyInfo?.full_name ??
    agencyInfo?.agency_name ??
    agencyInfo?.company_name ??
    "Agency";
  const addressParts = [
    agencyInfo?.address1 ?? agencyInfo?.address_1,
    agencyInfo?.city,
    agencyInfo?.zip,
  ].filter(Boolean);
  const companyAddress = addressParts.join(", ") || "N/A";

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 14;
  let y = margin;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(companyName, pageWidth / 2, y, { align: "center" });
  y += 7;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(companyAddress, pageWidth / 2, y, { align: "center" });
  y += 8;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Report : Billing Status Report", pageWidth / 2, y, {
    align: "center",
  });
  y += 6;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    `Report generated on ${moment().format("MM/DD/YYYY hh:mm:ss A")}`,
    pageWidth / 2,
    y,
    { align: "center" },
  );
  y += 10;

  items.forEach((item, claimIndex) => {
    const legs = getSubmissionBillingLegs(item);
    const nemtServiceRate = item?.nemtServiceRate ?? {};
    const passengerDetails = getSubmissionPassengerDetails(item);
    const billingStatus = getSubmissionBillingStatusLabel(item?.bill_status);
    const claimTotals = getSubmissionClaimTotals(item, legs, nemtServiceRate);
    const summaryLineCount =
      3 + (passengerDetails.hasServiceAuth ? 1 : 0);

    const estimatedClaimHeight =
      summaryLineCount * 7 +
      20 +
      (legs.length > 0 ? legs.length + 2 : 2) * 10;
    if (claimIndex > 0 && y + estimatedClaimHeight > pageHeight - margin) {
      doc.addPage();
      y = margin;
    } else if (claimIndex > 0) {
      y += 6;
    }

    y = drawSubmissionClaimInfoBox(
      doc,
      y,
      passengerDetails,
      getSubmissionProcedureCode(item),
      margin,
      pageWidth,
    );

    const tableBody =
      legs.length === 0
        ? [
            [
              formatPdfDate(item?.schedule_date),
              "N/A",
              "N/A",
              "N/A",
              billingStatus,
            ],
          ]
        : legs.map((leg, legIdx) => {
            const legAmount = calculateSubmissionLegAmount(leg, nemtServiceRate);
            return [
              formatPdfDate(item?.schedule_date),
              formatSubmissionDriverLabel(leg, legIdx),
              leg?.miles ?? "N/A",
              formatSubmissionCurrencyAmount(legAmount),
              billingStatus,
            ];
          });

    const totalRowIndex = tableBody.length;
    tableBody.push([
      "Total",
      "",
      claimTotals.totalMiles,
      claimTotals.totalAmount,
      "",
    ]);

    autoTable(doc, {
      startY: y,
      head: [["Date", "Driver", "Miles", "Amount", "Billing Status"]],
      body: tableBody,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [90, 90, 90],
        textColor: 255,
        fontStyle: "bold",
        halign: "center",
      },
      columnStyles: {
        0: { halign: "center" },
        2: { halign: "center" },
        3: { halign: "center" },
        4: { halign: "center" },
      },
      margin: { left: margin, right: margin },
      didParseCell: (data) => {
        if (
          data.section === "body" &&
          data.row.index === totalRowIndex
        ) {
          data.cell.styles.fillColor = [230, 230, 230];
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    y = (doc.lastAutoTable?.finalY ?? y) + 8;
  });

  doc.save(fileName);
};

export function restrictSpecialCharacters(e) {
  const key = e.key;

  // Allow control keys like Backspace, arrows, etc.
  if (
    key === "Backspace" ||
    key === "Tab" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Delete"
  ) {
    return; // allow
  }

  // Allow only alphanumeric and space
  const isValid = /^[a-zA-Z0-9 ]$/.test(key);
  if (!isValid) {
    e.preventDefault();
  }
}
export function CustomSwal() {
  Swal.mixin({
    allowOutsideClick: false,
    // You can add more default options here
  });
}
export function onlyNumberInput(e) {
  const zipInput = e.target;
  const value = zipInput.value.replace(/[^0-9]/g, "");

  zipInput.value = value;
}
export const exportToExcel = (data, fileName = "export") => {
  //const exportToExcel = () => {
  console.log("exportToExcel called with data:", data);
  const originalTable = data;
  if (!originalTable) {
    console.warn("Table not found");
    return;
  }
  // Clone the table to modify it without affecting the original DOM
  const clonedTable = originalTable.cloneNode(true);

  // Remove all <td> and <th> elements with the class 'no-export'
  clonedTable.querySelectorAll(".no-export").forEach((el) => el.remove());
  // Hide icons and UI elements
  clonedTable
    .querySelectorAll(".visible-odometer")
    .forEach((el) => el.remove());
  const worksheet = XLSX.utils.table_to_sheet(clonedTable);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Trip Data");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, `${fileName}.xlsx`);
  //}
};
/**
 * Exports a DOM element to PDF file using html2canvas + jsPDF.
 * @param {HTMLElement} element - The DOM element to capture (e.g. div or table ref).
 * @param {string} fileName - The name for the downloaded PDF file.
 */

export const exportFullTableToPDF = async (
  ref,
  setShowAllRowsForExport,
  fileName = "Trip_Report.pdf"
) => {
  if (!ref?.current) {
    console.warn("No table ref provided");
    return;
  }

  try {
    //setShowAllRowsForExport(true);
    await new Promise((res) => setTimeout(res, 300)); // wait for full DOM render

    const element = ref.current;

    // 1. Hide unwanted columns
    const hiddenEls = element.querySelectorAll(".no-pdf, .no-export");
    hiddenEls.forEach((el) => (el.style.display = "none"));

    // 2. Fix alignment for .align-middle
    const alignMiddleTds = element.querySelectorAll("td.align-middle");
    alignMiddleTds.forEach((td) => {
      td.dataset.restoreAlignMiddle = "true";
      td.classList.remove("align-middle");
      td.style.verticalAlign = "top";
    });

    // 3. Expand ellipsis content
    const ellipsisElements = element.querySelectorAll(".ellipsis");
    ellipsisElements.forEach((el) => {
      el.dataset.originalStyle = el.getAttribute("style") || "";
      el.style.whiteSpace = "normal";
      el.style.overflow = "visible";
      el.style.textOverflow = "unset";
    });

    // 4. Force page breaks after each schedule group
    // const groups = element.querySelectorAll('.pdf-break-group');
    // groups.forEach((group, idx) => {
    //   if (idx < groups.length - 1) {
    //     group.classList.add('pdf-page-break');
    //     group.style.pageBreakAfter = 'always';
    //     group.style.breakAfter = 'page';
    //   }
    // });

    // 5. Apply export-specific styles
    const originalStyles = {
      transform: element.style.transform,
      width: element.style.width,
      minWidth: element.style.minWidth,
      paddingLeft: element.style.paddingLeft,
    };

    // element.style.transformOrigin = 'top left';
    // element.style.transform = 'scale(0.75)';
    // element.style.width = '1300px';
    // element.style.minWidth = '1300px';
    // element.style.paddingLeft = '20px';

    // 3.5 Remove anchor tags (convert <a> to <span> with text only)
    const anchorElements = element.querySelectorAll("a");
    const anchorReplacements = []; // For restoring later

    anchorElements.forEach((a) => {
      const span = document.createElement("span");
      span.textContent = a.textContent;
      anchorReplacements.push({ original: a, replacement: span });
      a.parentNode.replaceChild(span, a);
    });

    // 6. Inject print CSS
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      @media print {
        .pdf-page-break {
          page-break-after: always;
          break-after: page;
        }
        table, th, td {
          border: 1px solid #333 !important;
          border-collapse: collapse !important;
        }
        tr:last-child td, .pdf-break-group:last-child tr:last-child td {
          border-bottom: 2px solid #333 !important;
        }
      }
    `;
    document.head.appendChild(styleTag);

    // 7. PDF export
    await html2pdf()
      .set({
        //margin: [0.5, 0.3, 0.6, 0.3],
        filename: fileName,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "landscape",
        },
      })
      .from(element)
      .save();

    // 8. Cleanup
    element.style.transform = originalStyles.transform;
    element.style.width = originalStyles.width;
    element.style.minWidth = originalStyles.minWidth;
    element.style.paddingLeft = originalStyles.paddingLeft;

    hiddenEls.forEach((el) => (el.style.display = ""));

    alignMiddleTds.forEach((td) => {
      if (td.dataset.restoreAlignMiddle) {
        td.classList.add("align-middle");
        delete td.dataset.restoreAlignMiddle;
      }
      td.style.verticalAlign = "";
    });

    ellipsisElements.forEach((el) => {
      el.setAttribute("style", el.dataset.originalStyle);
      delete el.dataset.originalStyle;
    });

    // Restore anchor tags
    anchorReplacements.forEach(({ original, replacement }) => {
      replacement.parentNode.replaceChild(original, replacement);
    });
    // groups.forEach(group => {
    //   group.classList.remove('pdf-page-break');
    //   group.style.pageBreakAfter = '';
    //   group.style.breakAfter = '';
    // });

    if (styleTag && styleTag.parentNode) {
      styleTag.parentNode.removeChild(styleTag);
    }

    setShowAllRowsForExport(false);
  } catch (err) {
    console.error("PDF Export failed:", err);
    setShowAllRowsForExport(false);
  }
};

// export const exportFullTableToPDF = async (
//   ref,
//   setShowAllRowsForExport,
//   fileName = 'Trip_Table.pdf'
// ) => {
//   if (!ref?.current) {
//     console.warn('No table element provided');
//     return;
//   }

//   try {
//     // 1. Temporarily show all rows (remove pagination)
//     //setShowAllRowsForExport(true);
//     await new Promise((resolve) => setTimeout(resolve, 300)); // Allow DOM to update

//     const tableEl = ref.current;
// if (!tableEl || tableEl.nodeName !== 'TABLE') {
//       console.warn('The ref must point directly to a <table> element.');
//       return;
//     }
//     // 2. Hide any .no-pdf content
//     const hiddenEls = tableEl.querySelectorAll('.no-pdf');
//     hiddenEls.forEach((el) => (el.style.display = 'none'));

//     // 3. Generate PDF using actual <table>
//     const doc = new jsPDF();
//     autoTable(doc, {
//       html: tableEl,
//       startY: 20,
//       styles: { fontSize: 8, cellPadding: 2 },
//       headStyles: { fillColor: [40, 167, 69] },
//     });

//     doc.save(fileName);
//   } catch (error) {
//     console.error('PDF export failed:', error);
//   } finally {
//     // 4. Restore hidden elements and pagination
//     const tableEl = ref.current;
//     if (tableEl) {
//       const hiddenEls = tableEl.querySelectorAll('.no-pdf');
//       hiddenEls.forEach((el) => (el.style.display = ''));
//     }
//     setShowAllRowsForExport(false);
//   }
// };

//import html2pdf from 'html2pdf.js';

// export const exportFullTableToPDF = async (
//   ref,
//   setShowAllRowsForExport,
//   fileName = 'Trip_Report.pdf'
// ) => {
//   if (!ref?.current) {
//     console.warn('No table ref provided');
//     return;
//   }

//   try {
//     // Step 1: Expand all rows if needed
//     setShowAllRowsForExport(true);
//     await new Promise((res) => setTimeout(res, 500)); // Wait for DOM to update

//     // Step 2: Clone the live table (deep clone)
//     const originalElement = ref.current;
//     const clone = originalElement.cloneNode(true);
//     clone.id = 'pdf-clone';
//     clone.style.position = 'absolute';
//     clone.style.top = '-9999px';
//     clone.style.left = '-9999px';
//     clone.style.zIndex = '-1';

//     document.body.appendChild(clone);

//     // Step 3: Replace <a> with plain text
//     const anchorElements = clone.querySelectorAll('a');
//     anchorElements.forEach((a) => {
//       const span = document.createElement('span');
//       span.textContent = a.textContent;
//       a.parentNode.replaceChild(span, a);
//     });

//     // Step 4: Hide unwanted columns
//     const hiddenEls = clone.querySelectorAll('.no-pdf, .no-export');
//     hiddenEls.forEach(el => el.style.display = 'none');

//     // Step 5: Fix alignment
//     const alignMiddleTds = clone.querySelectorAll('td.align-middle');
//     alignMiddleTds.forEach(td => {
//       td.classList.remove('align-middle');
//       td.style.verticalAlign = 'top';
//     });

//     // Step 6: Expand ellipsis content
//     const ellipsisElements = clone.querySelectorAll('.ellipsis');
//     ellipsisElements.forEach(el => {
//       el.style.whiteSpace = 'normal';
//       el.style.overflow = 'visible';
//       el.style.textOverflow = 'unset';
//     });

//     // Step 7: Add page break after each group
//     const groups = clone.querySelectorAll('.pdf-break-group');
//     groups.forEach((group, idx) => {
//       if (idx < groups.length - 1) {
//         group.classList.add('pdf-page-break');
//         group.style.pageBreakAfter = 'always';
//         group.style.breakAfter = 'page';
//       }
//     });

//     // Step 8: Scale and style for PDF
//     clone.style.transformOrigin = 'top left';
//     clone.style.transform = 'scale(0.75)';
//     clone.style.width = '1300px';
//     clone.style.minWidth = '1300px';
//     clone.style.paddingLeft = '20px';

//     // Step 9: Inject print CSS for borders
//     const styleTag = document.createElement('style');
//     styleTag.innerHTML = `
//       @media print {
//         .pdf-page-break {
//           page-break-after: always;
//           break-after: page;
//         }
//         table, th, td {
//           border: 1px solid #333 !important;
//           border-collapse: collapse !important;
//         }
//         tr:last-child td, .pdf-break-group:last-child tr:last-child td {
//           border-bottom: 2px solid #333 !important;
//         }
//       }
//     `;
//     document.head.appendChild(styleTag);

//     // Step 10: Use html2pdf
//     await html2pdf().set({
//       margin: 0.3,
//       filename: fileName,
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: {
//         scale: 2,
//         useCORS: true,
//         allowTaint: true,
//         logging: true
//       },
//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'landscape',
//       },
//     }).from(clone).save();

//     // Step 11: Cleanup
//     if (styleTag && styleTag.parentNode) {
//       styleTag.parentNode.removeChild(styleTag);
//     }
//     document.body.removeChild(clone);
//     setShowAllRowsForExport(false);

//   } catch (err) {
//     console.error('PDF Export failed:', err);
//     setShowAllRowsForExport(false);
//   }
// };
